import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MarkdownIcon from './MarkdownIcon';
import './module.css';

const MarkdownLink = ({ floatRight }) => {
  return (
    <a
      href="http://commonmark.org/help/"
      rel="noopener noreferrer"
      target="_blank"
      styleName={classNames('link', { 'float-right': floatRight })}
    >
      <MarkdownIcon /> Styling with Markdown is Supported
    </a>
  );
};

MarkdownLink.propTypes = {
  floatRight: PropTypes.bool
};

MarkdownLink.defaultProps = {
  floatRight: false
};

export default MarkdownLink;
